//import logo from './logo.svg';
//import './App.css';
import React from "react";
import Die from "./components/Die";
import Cheers from "./components/Cheers";


function App() {
  //['⚽', '🥊', '🥎', '🎾','🏒', '🏀', '🏐', '🏈', '🎳']
  const sportsList =['⚽', '🥎', '🎾', '🏀', '🏐', '🎳']
  const [sportsArr, setSportsArr] = React.useState(() => generateAllNewDice())
  const buttonRef = React.useRef(null)

  const gameWon = sportsArr.every(sport => sport.isHeld) && 
  sportsArr.every(sport => sport.value === sportsArr[0].value)

  React.useEffect(() => {
    if(gameWon){
      buttonRef.current.focus()
    }
  }, [gameWon])
  
  function generateAllNewDice(){
    const newDice = []

    //at the time this was created, the development is not online
    //in place of the nanoid, I will just use the increment i for the keys

    for (let i= 0; i< 10; i++){
      const rand = Math.floor(Math.random() * sportsList.length)
      newDice.push({
        value: sportsList[rand],
        isHeld: false,
        id: i
      })

    }
    return newDice
  }

  function rollDice(){
    if(!gameWon){
      setSportsArr(oldSportsArr => oldSportsArr.map(sport =>
      sport.isHeld ? 
        sport : 
        {...sport, value: sportsList[Math.floor(Math.random() * sportsList.length)]}
      ))
    } else {
      setSportsArr(generateAllNewDice())
    }
  }

  function hold(id){
    setSportsArr(oldSportsArr => oldSportsArr.map(sport => 
      sport.id === id ? 
      {...sport, isHeld: !sport.isHeld} : 
      sport
    ))
  }

  const sportElements = sportsArr.map(sport => (
    <Die 
      key={sport.id} 
      value={sport.value} 
      isHeld={sport.isHeld}
      hold = {() => hold(sport.id)}
    />

  ))

  return (
    <main>
      {gameWon && <Cheers>Awesome Job! Congratulations for matching all blocks. Click Close and hit the New Game button to play again</Cheers>}
      <div aria-live="polite" className="sr-only">
        {gameWon && <p>Congratulations! You won! Hit "New Game" to start again</p>}
      </div>
      <h1 className="title">Sports Tenzies</h1>
      <p className="instructions">Roll until all blocks are the same. click each block to freeze it and its current sport between rolls</p>
      <div className="dice-container">
        { sportElements }
      </div>
      <button ref={buttonRef} className="roll-dice" onClick={rollDice}>
        {gameWon ? "New Game" : "Roll It"}</button>
      <p>By Jun Dolor, click to view my ➡️ <a href="https://www.linkedin.com/in/jun-dolor/" target="_blank" rel="noreferrer">LinkedIn profile</a></p>
    </main>
  );
}

export default App;
